<script>
import { mapGetters } from 'vuex';
import i18n from './i18n';
import Wrapper from 'ne01-common/src/components/Wrapper';
import QuizPage from './containers/QuizPage.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import LoadIndicator from './components/LoadIndicator.vue';
import SpectroPage from './containers/SpectroPage.vue';

export default {
  name: 'app',
  components: {
    Wrapper,
    ErrorMessage,
    LoadIndicator,
    QuizPage,
    SpectroPage,
  },
  mounted() {
    if(!window.apiUrl) {
      window.apiUrl = 'https://lasauge.bird-song.ch';
    }
    if(!window.cmsUrl) {
      window.cmsUrl = 'https://wp.ls.bird-song.ch';
    }
    if(!window.cmsSlug) {
      window.cmsSlug = 'station-2';
    }

    const visitorId = new URL(window.location.href).searchParams.get('visitor') || 1;
    const lang = new URL(window.location.href).searchParams.get('lang') || 'de';

    this.$store.dispatch('initApp', { visitorId, lang });
    this.$store.dispatch('loadCmsData', lang);

    i18n.locale = lang;
  },
  methods: {
    loadCmsData() {
      this.$store.dispatch('loadCmsData');
    },
    retryLoading() {
      if (this.lastAction === 'loadCmsData')
        this.loadCmsData();
      if (this.lastAction === 'sendStatistics')
        this.unloadStation();
    },
    unloadStation() {
      if (this.hasStarted) 
        this.$store.dispatch('sendStatistics', { ...this.statisticsTotals.normalized, visitor_id: this.visitorId, station_id: 2 });
      else 
        window.postMessage('end');
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLang',
      loading: 'getShowLoadindicator',
      error: 'getDataLoadError',
      introText: 'getStationIntro',
      heading: 'getStationHeading',
      screenState: 'getStationScreenState',
      introTrack: 'getStationIntroTrack',
      lastAction: 'getLastHttpAction',
      statisticsTotals: 'getStatisticsTotals',
      hasStarted: 'getHasStarted',
      visitorId: 'getVisitorId',
    })
  }
};
</script>

<template>
  <div id="app">
    <Wrapper v-if="!loading && !error" v-bind:src="introTrack" nr="2" v-bind:heading="heading" v-on:exit="unloadStation">
      <div class="station-content">
        <quiz-page v-if="screenState === 'quiz'" />
        <spectro-page v-if="screenState === 'spectro'" v-on:unloadStation="unloadStation" />
      </div>
      <p slot="intro">{{introText}}</p>
    </Wrapper>

    <div class="load-indicator" v-if="loading">
      <load-indicator></load-indicator>
    </div>

    <error-message v-bind:error="error" v-on:reloadData="retryLoading()"></error-message>

  </div>
</template>



<style lang="scss">
@import './assets/styles/variables';

#app {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  font-family: var(--font-family-secondary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--dark, black);
  background: var(--color-mainm, #CCC);
}
.station-content {
  position: absolute;
  box-sizing: border-box;
  top: 0; left: 0; width: 100%; height: 100%;
  min-height: 100%;
  padding-top: calc(var(--gutter) * 5);
  overflow-y: auto;
}
.load-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
